import wixWindow from 'wix-window';
import {fetch} from 'wix-fetch';

$w.onReady(function () {
	if(wixWindow.formFactor === "Mobile"){ //&&
		//wixWindow.rendering.renderCycle === 1) {
		$w("#imageVideo").show();
		//$w("#button11").hide();
	}
});

// For full API documentation, including code examples, visit http://wix.to/94BuAAs
$w.onReady(function () {
	let startNum = 1000000;
	let endNum = 51000000;
	const duration =  30; // 1000 milliseconds 
	let intervalId;

	 let interval = setInterval(()=> {
			if (isNaN(wixWindow.rendering.renderCycle))
			{
				if(wixWindow.formFactor !== "Mobile")
					$w('#box2').show();
				setInterval(()=> {
					countUp(); 	
				}, duration)
				clearInterval(interval);
			}
		}, 300);
	//$w('#moneyText').text = "2";
	//$w('#moneyText').text = "\u200A" + "2";
	//return;
	//TODO: write your page related code here...

	/*setTimeout(() =>
		intervalId = setInterval(()=> {
			countUp(); 	
		}, duration),
		1200);*/
	

	const padWithZeros = (x, len) => {
		while (x.length < len) {
			x = "0" + x;
		}
		return x;
	}

	function countUp(){	
		if (startNum <= endNum ){
			var singles = startNum % 1000;
			var thousands = Math.floor((startNum % 1000000) / 1000);
			var mills = Math.floor(startNum / 1000000);
			$w('#moneyTextSingles').text = padWithZeros(singles.toString(), 3);
			$w('#moneyTextThousands').text = padWithZeros(thousands.toString(), 3);
			$w('#moneyTextMills').text = padWithZeros(mills.toString(), 2);


			//$w('#moneyTextSingles') = p singles.toString().padStart()

			//var a = numberWithCommas((startNum).toString());
			//if (a.length === 9)
			//	a = "0" + a;
			//
			//$w('#moneyText').text =  a;
			//while ($w('#moneyText').text.length < 8)
			//	$w('#moneyText').text = '0' + $w('#moneyText').text;
			//startNum += 957873;
			startNum += 235787;
		}
		else clearInterval(intervalId)
	}

	const numberWithCommas = (x) => {
		//return x;
 		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

	/*function addCommasToStringOfNumber(numString){
		let newNumString = numString.split("").reverse();
		
		for (let i = 0; i < numString.length; i++){
			if (i % 3 === 0 && i !== 0 ){
				newNumString.splice( i, 0 , ",");			
			}		
		}
		
		newNumString = newNumString.reverse().join("");
		return newNumString;
	}*/
});

export function image3_click(event, $w) {

	$w('#fullWidthSlides2').changeSlide(2);
}

export function columnStrip6_click(event, $w) {

	$w('#fullWidthSlides2').changeSlide(2);//.then(() => ), onRejected);
}

function errorMessage(msg) {
	$w('#text98').text = msg;
	$w('#text98').show();
}

function successMessage(msg) {
	$w('#text98').text = msg;
	$w('#text98').show("fade");
}

import {submitContactForm} from 'backend/formSubmit';

export function contactFormSubmitClick(event, $w) {
	//successMessage($w('#nameInput').valid.toString());
	if (! $w('#fnameInput').valid)
		errorMessage("אנא הזן שם פרטי");
	else if (! $w('#lnameInput').valid)
		errorMessage("אנא הזן שם משפחה");	
	else if (! $w('#emailInput').valid)
		errorMessage('אנא הזן כתובת דוא""ל חוקית');
	else if (! $w('#phoneInput').valid)
		errorMessage('אנא הזן טלפון');
	else if (! $w('#commentTextBox').valid)
		errorMessage('אנא הזן מהות פנייה');
	else if (! $w('#termsCheckbox').checked)
		errorMessage('אנא אשר קבלת דיוור');
	else
	{
		submitContactForm($w('#fnameInput').value, $w('#lnameInput').value, $w('#emailInput').value, $w('#phoneInput').value, $w('#commentTextBox').value).then( (httpResponse) => {
			//showGetLecuresMessage("תודה! ניצור עמך קשר בהקדם.");
			//successMessage(httpResponse);
			$w('#fnameInput').value = "";
			$w('#fnameInput').resetValidityIndication();
			$w('#lnameInput').value = "";
			$w('#lnameInput').resetValidityIndication();
			$w('#emailInput').value = "";
			$w('#emailInput').resetValidityIndication();
			$w('#phoneInput').value = "";
			$w('#phoneInput').resetValidityIndication();
			$w('#commentTextBox').value = "";
			$w('#commentTextBox').resetValidityIndication();
			$w('#termsCheckbox').checked = false;
			$w('#termsCheckbox').resetValidityIndication();
			successMessage("תודה! ניצור עמך קשר בהקדם.");
		}).catch(function(ex) {
    		console.log('failed: ', ex)
  		});
	}
}

function showGetLecuresMessage(msg) {
	$w('#text100').text = msg;
	$w('#text100').show();
}

import {submitForm} from 'backend/formSubmit';

export function getLectureSubmitClick(event, $w) {
	if (! $w('#lecturesNameinput').valid)
		showGetLecuresMessage("אנא הזן שם");
	else if (! $w('#lecturesMailinput').valid)
		showGetLecuresMessage('אנא הזמן כתובת דוא""ל חוקית');
	else
	{
		/*let headers = {
        	"Content-type": "application/x-www-form-urlencoded"
    	};
		let body = "fields[subscribers_name]=" + $w('#lecturesNameinput').value +
			"&fields[subscribers_email]=" + $w('#lecturesMailinput').value + 
			"&fields[subscribers_phone]=" + "&fields[ref]=&form_id=829599&encoding=UTF-8";
		let options = {
        	method: 'POST',
        	headers: headers,
        	body: encodeURI(body)
    	};*/

		//showGetLecuresMessage("hi14");
		submitForm($w('#lecturesNameinput').value, $w('#lecturesMailinput').value).then( (httpResponse) => {
			showGetLecuresMessage("תודה! ניצור עמך קשר בהקדם.");
			//showGetLecuresMessage(httpResponse);
			$w('#lecturesNameinput').value = "";
			$w('#lecturesNameinput').resetValidityIndication();
			$w('#lecturesMailinput').value = "";
			$w('#lecturesMailinput').resetValidityIndication();
		}).catch(function(ex) {
    		console.log('failed: ', ex)
  		});
		/*fetch("subscribe.responder.co.il/", options).then( (httpResponse) => {
			showGetLecuresMessage("תודה! ניצור עמך קשר בהקדם.");
			showGetLecuresMessage(httpResponse);
			$w('#lecturesNameinput').value = "";
			$w('#lecturesNameinput').resetValidityIndication();
			$w('#lecturesMailinput').value = "";
			$w('#lecturesMailinput').resetValidityIndication();
		}).catch(function(ex) {
    		console.log('parsing failed', ex)
  		})*/
	}
}
